import store from '@/store';

export default {
  currentUser: () => {
    const user = store.getters['user/user'];
    const company = store.getters['company/company'];
    return {
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      email: user.email || '',
      phone_number: user.phone_number || '',
      role_code: user.role_code || '',
      user_id: user.user_id || '',
      user_status: user.user_status || '',
      company_address: company.company_address || '',
      company_city: company.company_city || '',
      company_country_name: company.company_country_name || '',
      company_id: company.company_id || '',
      company_name: company.company_name || '',
      company_state: company.company_state || '',
      company_symbol: company.company_symbol || '',
      company_zip_code: company.company_zip_code || '',
      parent_company_id: company.parent_company_id || '',
      parent_company_name: company.parent_company_name || '',
    };
  },
  isAuth: () => {
    const auth = JSON.parse(localStorage.getItem('vuex')).auth || null;
    return auth.isAuthenticated || false;
  },
};
